
import { baseNavItems, type ScreenId } from "../nav";

export function StubScreen({
  screen,
  onOpenSpec
}: {
  screen: ScreenId;
  onOpenSpec: () => void;
}) {
  const label = baseNavItems.find((item) => item.id === screen)?.label ?? "Coming soon";

  return (
    <div className="flex flex-1 items-center justify-center p-10">
      <div className="max-w-[380px] text-center">
        <div className="mx-auto mb-4 h-[46px] w-[46px] rounded-xl bg-[var(--line)]" />
        <div className="text-[17px] font-extrabold">{label}</div>
        <p className="mt-2 text-[13px] leading-[1.5] text-[var(--muted2)]">
          Part of the wider specification engine. The implemented v0.5 screens bind to
          real view-model data; this screen is intentionally stubbed for the next UI
          wave.
        </p>
        <button
          type="button"
          onClick={onOpenSpec}
          className="mt-4 rounded-[10px] bg-[var(--ink)] px-4 py-2.5 text-[13px] font-bold text-[var(--onSolid)]"
        >
          Open Spec workspace
        </button>
      </div>
    </div>
  );
}
